// statistics.api.ts
import {client} from '@/lib/httpClient';
import {Statistic} from "@/types/statistic.types";

export const statisticsApi = {
    getAll: async () => {
        const response = await client.get<Statistic[]>("/api/v1/statistics");
        return response.data;
    },
};